import script from "./BCUnit.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCUnit.vue?vue&type=script&lang=ts&setup=true"

import "./BCUnit.vue?vue&type=style&index=0&id=16887a75&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16887a75"]])

export default __exports__